// packages
import { h } from 'preact';

// internal
import serialize from '../utils/serialize-query-string';

function YouTubeIframe({ id }) {
  const params = serialize({
    autoplay: 1,
    color: 'white',
    playsinline: 1,
    modestbranding: 1,
  });

  return (
    <iframe
      class="embed-responsive__item"
      src={`https://www.youtube.com/embed/${id}?${params}`}
      frameborder="0"
      allow="autoplay; encrypted-media; picture-in-picture"
      allowfullscreen
    />
  );
}

export default YouTubeIframe;
